module.exports = __webpack_public_path__ + "img/Q4.f0a36ca1.png";